const TokenKey = "Token";
const UserIdKey = "UserId";
const RefreshTokenKey = "RefreshToken";

export function getToken () {
  return localStorage.getItem(TokenKey);
}

export function setToken (token) {
  if (token) {
    localStorage.setItem(TokenKey, token);
  }
}

export function getRefreshToken () {
  return localStorage.getItem(RefreshTokenKey);
}

export function setUserId (userId) {
  if (userId) {
    localStorage.setItem(UserIdKey, userId);
  }
}

export function getUserId () {
  return localStorage.getItem(UserIdKey);
}

export function setRefreshToken (refreshToken) {
  if (refreshToken) {
    localStorage.setItem(RefreshTokenKey, refreshToken);
  }
}

export function clearSessionStorage () {
  localStorage.clear();
}
